import elementsArrayToKeys from './parse/elementsArrayToKeys'
import parseBases from './parse/parseBases'
import parseBrandInfoFromBuckets from './parse/parseBrandInfoFromBuckets'
import parseBrands from './parse/parseBrands'
import parseBuckets from './parse/parseBuckets'
import parseCategories from './parse/parseCategories'
import parseElements from './parse/parseElements'
import parseProducts from './parse/parseProducts'

// The default created by
const DEFAULT_CREATED_BY = 'metropolis-world'

/**
 * Parse the persona data
 *
 * @param {object} props - the input props
 * @returns {object} the parsed output
 */
export default function parsePersonaData (props) {
  const {
    bases,
    brandBuckets,
    brands: brandsInput,
    categoryConfig,
    elements: elementsInput,
    prices,
    supply,
    utilityConfig
  } = props
  const brands = parseBrands(brandsInput)
  const elements = parseElements({
    DEFAULT_CREATED_BY,
    brands,
    elements: elementsInput,
    prices,
    supply,
    categoryConfig,
    utilityConfig
  })

  // Convert the elements array as an object, keyed by ID, for faster lookup
  const elementsKeys = elementsArrayToKeys(elements)
  const products = parseProducts(elements)
  const buckets = parseBuckets({
    categories: {
      ...parseCategories({
        categoryConfig,
        elements
      }),
      base: parseBases({ bases, elementsKeys })
    },
    categoryConfig,
    brands,
    brandBuckets
  })

  const brandInfo = parseBrandInfoFromBuckets(buckets)

  const res = {
    ...buckets,
    elements: elementsKeys,
    products,
    brandInfo,
    brands
  }

  return res
}
